import type { RefObject } from "react";

export function TextInput({
	ref,
	...props
}: {
	ref?: RefObject<HTMLInputElement | null>;
} & React.ButtonHTMLAttributes<HTMLInputElement>) {
	return (
		<input
			type="text"
			className="bg-gray-50 text-black border border-gray-500 pl-2 pr-2 pt-1 pb-1 rounded-md cursor-text"
			ref={ref}
			{...props}
		/>
	);
}

export function EmailInput({
	ref,
	...props
}: {
	ref?: RefObject<HTMLInputElement | null>;
} & React.ButtonHTMLAttributes<HTMLInputElement>) {
	return (
		<input
			type="email"
			className="bg-gray-50 text-black border border-gray-500 pl-2 pr-2 pt-1 pb-1 rounded-md cursor-text"
			placeholder="example@gmail.com"
			ref={ref}
			{...props}
		/>
	);
}
